import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import TotalOdd from '../../common/totalOdd';

const ResultReport = ({ reportList, precision }) => {
  return (
    <div className='fs-hunted-fish-list-wrapper'>
      <div className='fs-hunted-fish-list'>
        {reportList.map((el, index) => {
          const fishResult = reportList[index];
          const key = `${index}_${fishResult?.resultType}_${fishResult?.odd}_${fishResult?.animation}`;
          return (
            <div
              key={key}
              className={`fs-hunted-fish-wrapper ${!index ? 'active' : ''} ${
                fishResult?.animation ? 'fish-row-animation' : ''
              }`}
            >
              <span>{fishResult?.odd !== undefined ? `x${fishResult?.odd}` : ' '}</span>
            </div>
          );
        })}
      </div>
      {isMobile() && <TotalOdd precision={precision} reportList={reportList} />}
    </div>
  );
};
export default ResultReport;
